export const FETCH_REPORT_REQUEST = 'FETCH_REPORT_REQUEST';
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS';
export const FETCH_REPORT_FAILURE = 'FETCH_REPORT_FAILURE';

export const DOWNLOAD_REPORT_REQUEST_START = 'DOWNLOAD_REPORT_REQUEST_START';
export const DOWNLOAD_REPORT_REQUEST_END = 'DOWNLOAD_REPORT_REQUEST_END';